import Vue from "vue";
import Vuex from "vuex";
import user from "../user";
import { getJSON, GMMOBILE_HOST, getHrefParam } from "../ultile";

export const FOOTER_LINK = "getFooterLink";
export const FB_LINK = "getFbLink";
export const UNREAD_MSG = "getUnreadMsg";
export const CHANGE_FB_INFO = "changeFbInfo";
export const LOAD_FB_INFO = "loadFbInfo";
const UPDATE_FOOTER_LINK = "updataFooterLink";
export const UPDATE_TIP_MSG = "updateTipMsg";
const UPDATE_FB_LINK = "unpdateFbLink";
const UPDATE_UNREAD_MSG = "updateUnreadMsg";

Vue.use(Vuex);
let emptyFbInfo = {
  appName: "",
  appImg: ""
};
export default {
  strict: process.env.NODE_ENV !== "production", //在非生产环境下，使用严格模式
  state: {
    footerLink: "",
    tipMsg: "",
    fbLink: "",
    unreadMsg: 0,
    fbInfo: emptyFbInfo,
    showFullScreen: false
  },
  mutations: {
    [UPDATE_FOOTER_LINK](state, status) {
      state.footerLink = status;
    },
    [UPDATE_TIP_MSG](state, status) {
      state.tipMsg = status;
    },
    [UPDATE_UNREAD_MSG](state, status) {
      state.unreadMsg = status;
    },
    [CHANGE_FB_INFO](state, info) {
      if (info) {
        state.fbInfo.appName = info.appName;
        state.fbInfo.appImg = info.LOGO_URL;
      } else {
        state.fbInfo = emptyFbInfo;
      }
    },
    toggleFullScreenState(state) {
      state.showFullScreen = !state.showFullScreen;
    }
  },
  actions: {
    [FOOTER_LINK]({ commit }, params) {
      let url = "https://www.gm99.com/ajax/get_flink_h5";
      return new Promise((resolve, reject) => {
        getJSON(url, { type: 0 }).then(({ errmsg, data, res }) => {
          if (errmsg) {
            reject(errmsg);
          } else {
            commit(UPDATE_FOOTER_LINK, res.data);
            resolve(true);
          }
        });
      });
    },
    [UPDATE_FB_LINK](state, status) {
      state.fbLink = status;
    },
    // [FB_LINK]({ commit }, params) {
    //     let url = '//www.gm99.com/ajax/get_flink';
    //     return new Promise((resolve, reject) => {
    //         getJSON(url, {})
    //             .then(({ errmsg, data, res }) => {
    //                 if (errmsg) {
    //                     reject(errmsg);
    //                 } else {
    //                     commit(UPDATE_FOOTER_LINK, res.msg);
    //                     resolve(true);
    //                 }
    //             })
    //     })
    // },

    [UNREAD_MSG]({ commit }, params) {
      let url = "https://www.gm99.com/message_api/query_msg?type=load";
      return new Promise((resolve, reject) => {
        getJSON(url, {}).then(({ errmsg, data, res }) => {
          if (errmsg) {
            resolve(false, errmsg);
          } else {
            if (res.code === 0) {
              resolve(false, "未登录");
            } else {
              commit(UPDATE_UNREAD_MSG, res.data.remain_msg);
              resolve(true);
            }
          }
        });
      });
    },
    [LOAD_FB_INFO]({ commit }) {
      var location = GMMOBILE_HOST + "h5/fbPlay/getAppInfo";
      var app_id = getHrefParam("app_id");
      var auth_uid = getHrefParam("auth_uid");
      getJSON(location, {
        app_id: app_id,
        access_token: auth_uid
      }).then(({ data, errmsg }) => {
        data = errmsg ? "" : data;
        commit(CHANGE_FB_INFO, data);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/pc/index.js